import { render, staticRenderFns } from "./Theme.vue?vue&type=template&id=2567010e&scoped=true"
import script from "./Theme.vue?vue&type=script&lang=ts"
export * from "./Theme.vue?vue&type=script&lang=ts"
import style0 from "./Theme.vue?vue&type=style&index=0&id=2567010e&prod&lang=scss&scoped=true"
import style1 from "./Theme.vue?vue&type=style&index=1&id=2567010e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2567010e",
  null
  
)

export default component.exports